import { PDFDocument } from "pdf-lib";

async function mergePDFs(pdfBytes) {
  try {
    const mergedPdf = await PDFDocument.create();
    const pdfDoc = await PDFDocument.load(pdfBytes, { ignoreEncryption: true });

    // Copy pages from the source PDF document to the merged PDF
    const copiedPages = await mergedPdf.copyPages(
      pdfDoc,
      pdfDoc.getPageIndices()
    );
    copiedPages.forEach((page) => mergedPdf.addPage(page));

    // Save or display the merged PDF
    const mergedPdfBytes = await mergedPdf.save();
    const mergedPdfBlob = new Blob([mergedPdfBytes], {
      type: "application/pdf",
    });
    const mergedPdfUrl = URL.createObjectURL(mergedPdfBlob);

 

    return mergedPdfUrl;
  } catch (error) {
    console.error("Error merging PDFs:", error);
    throw error; // Rethrow the error to handle it at a higher level if needed
  }
  // Release the object URL when it's no longer needed
  // URL.revokeObjectURL(mergedPdfUrl);
}

export default mergePDFs;
